import * as React from 'react';
import { Dropdown, Image } from 'react-bootstrap';
import { Tabs, Tab } from "react-bootstrap";
import { connect } from 'react-redux';
import './CarQuotation.css';
import { navigateTo } from '../../../../actions/navigationActions';
import { updateExcess, setIsOnQuoteScreen } from '../../../../actions/salesActions';
import { showAddVap, showAddAccessory, showAddCarHire, showAddCreditShortfall, showTyreAndRim, showAddLittleDings, showErrorModal } from '../../../../actions/modalActions';
import AcceptQuote from '../../AcceptQuote/AcceptQuote';
import { VAPS_ADD_TYRE_SCRATCH, VAPS_ADD_COMBINED } from "../../../../constants/copy";
import { refreshUpdatedCartItem } from '../../../../actions/cartActions';
import { BANKING_DETAILS } from '../../../../routes/routes';
import OptionalExtraTile from '../../../PersonalInsurance/OptionalExtraTile';
import AgreedValueBlock from '../../AgreedValue/AgreedValueBlock/AgreedValueBlock';
import { SA_COUNTRY_ID_NUMBER } from '../../../../constants/internationalization';
import { showModalCalculatorBroke } from '../../../../actions/salesModalActions';
import Dashboard from '../../../Dashboard/Dashboard';

class CarQuotation extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
            isInEdit: false,
            selectedExcessDropdown: false,
            showMore: false,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleExcessDropdownToggle = this.handleExcessDropdownToggle.bind(this);
        this.handleExcessSelection = this.handleExcessSelection.bind(this);
        this.handleShowMore = this.handleShowMore.bind(this);
        this.handleAddVap = this.handleAddVap.bind(this);
        this.handleAddAccesory = this.handleAddAccesory.bind(this);
        this.handleEditAccesory = this.handleEditAccesory.bind(this);
        this.handleAddVapCredit = this.handleAddVapCredit.bind(this);
        this.handleAddVapCarHire = this.handleAddVapCarHire.bind(this);
        this.handleAddVapTyreAndRim = this.handleAddVapTyreAndRim.bind(this);
        this.handleAddVapLittleDings = this.handleAddVapLittleDings.bind(this);
        this.handleAddVapScratchAndDent = this.handleAddVapScratchAndDent.bind(this);
        this.handleAcceptQuote = this.handleAcceptQuote.bind(this);
        this.setInQuoteScreen = this.setInQuoteScreen.bind(this);

    }

    setInQuoteScreen() {
        this.props.dispatchSetIsOnQuoteScreen(true, this.props.sales.quote.carId, this.props.sales.vehicleFullDescription);
    }

    async handleExcessSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let excessItem = this.props.sales.excessList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        if (excessItem[0].id !== this.props.sales.selectedExcess.id) {
            this.props.dispatchUpdateExcess(excessItem[0])
        }
    }

    async handleExcessDropdownToggle(e: any) {
        await this.setState({
            selectedExcessDropdown: !this.state.selectedExcessDropdown
        });
    }

    async handleShowMore(e: any) {
        await this.setState({
            showMore: !this.state.showMore
        });
    }

    async handleAcceptQuote(e: any) {
        this.props.dispatchSetIsOnQuoteScreen(false, "", "");
        if (this.props.sales.isNewItem) {
            this.props.dispatchAcceptQuote()
        }
        else {
            this.props.dispatchUpdateItemOnQuote()
        }
    }

    async handleChange(e: any) {
        let name = e.target.name;
        let value = e.target.value;
        await this.setState({ [name]: value });
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    componentWillMount() {

    }

    async handleAddAccesory(e: any) {
        let item = this.props.sales.carDetails.accessories.filter(accessory => accessory.id === e)
        this.props.dispatchShowAddAccessory(item[0])
    }

    async handleEditAccesory(e: any) {
        let item = this.props.sales.carDetails.accessories.filter(accessory => accessory.id === e)
        this.props.dispatchShowAddAccessory(item[0])
    }

    async handleAddVap(e: any) {
        this.props.dispatchShowAddVap(e)
    }

    async handleAddVapCarHire(e: any) {
        this.props.dispatchShowAddCarHire(e);
    }

    async handleAddVapTyreAndRim(e: any) {
        let selectedVap = this.props.sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        if (selectedVap.comboAdded) {
            this.props.dispatchShowErrorModal(VAPS_ADD_TYRE_SCRATCH)
        }
        else {
            this.props.dispatchShowTyreAndRim(e)
        }
    }

    async handleAddVapScratchAndDent(e: any) {
        let selectedVap = this.props.sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        if (selectedVap.comboAdded) {
            this.props.dispatchShowErrorModal(VAPS_ADD_TYRE_SCRATCH)
        }
        else {
            this.props.dispatchShowAddVap(e)
        }
    }

    async handleAddVapLittleDings(e: any) {
        let selectedVap = this.props.sales.carDetails.vaps.filter(vap => vap.id === e)[0]
        if (selectedVap.comboAdded) {
            this.props.dispatchShowErrorModal(VAPS_ADD_COMBINED)
        }
        else {
            this.props.dispatchShowAddLittleDings(e)
        }
    }

    async handleAddVapCredit(e: any) {
        this.props.dispatchShowAddCreditShortfall(e)
    }

    async handleAddVapRafAssist(e: any) {
        this.props.dispatchShowAddRafAssist(e)
    }

    componentDidMount() {
        this.setInQuoteScreen();
    }

    public render() {
        let vapsList = "";
        if (this.props.sales.carDetails?.vaps) {
            if (this.props.sales.carDetails.vaps.length > 0) {
                vapsList = this.props.sales.carDetails.vaps.map((item) => {
                    if (item.id.toUpperCase() === "4C0CB071-42DD-4060-99FF-9F0214113467") { /*credit shortfall*/
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={this.handleAddVapCredit.bind(this)}
                            removeItem={this.handleAddVapCredit.bind(this)}
                            canUse={true}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                            isAccessory={false} />
                    }
                    else if (item.id.toUpperCase() === "916E328E-AD96-4D6C-A3E8-42B095BCB805") {/*tyre and rim*/
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={this.handleAddVapTyreAndRim.bind(this)}
                            removeItem={this.handleAddVapTyreAndRim.bind(this)}
                            canUse={true}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                            isAccessory={false} />
                    }
                    else if (item.id.toUpperCase() === "0EC1DCAA-A6F7-4C86-905A-00FD55022569") {/*scratch and dent*/
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={this.handleAddVapScratchAndDent.bind(this)}
                            removeItem={this.handleAddVapScratchAndDent.bind(this)}
                            canUse={true}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                            isAccessory={false} />
                    }
                    else if (item.id.toUpperCase() === "5EEDC56C-F17A-4AB8-97CC-58E02D612865") {/*Little dings*/
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={(e) => this.handleAddVapLittleDings(e)}
                            removeItem={(e) => this.handleAddVapLittleDings(e)}
                            canUse={true}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                            isAccessory={false} />
                    }
                    else if (item.id.toUpperCase() === "4C0CB071-42DD-4060-99FF-9F0214113461") {/*car hire*/
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={this.handleAddVapCarHire.bind(this)}
                            removeItem={this.handleAddVapCarHire.bind(this)}
                            canUse={true}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                            isAccessory={false} />
                    }
                    else {
                        return <OptionalExtraTile id={item.id}
                            hasVAP={item.isActive}
                            productName={item.title}
                            imageClass={item.icon}
                            addItem={this.handleAddVap.bind(this)}
                            removeItem={this.handleAddVap.bind(this)}
                            canUse={true}
                            cost={this.props.profile.currencySymbol + " " + item.subtitle + " pm"}
                            isAccessory={false} />
                    }
                })
            }
        }

        let accessoryList = "";
        if (this.props.sales.carDetails?.accessories) {
            if (this.props.sales.carDetails.accessories.length > 0) {
                accessoryList = this.props.sales.carDetails.accessories.map((item) => {
                    return <OptionalExtraTile id={item.id}
                        hasVAP={item.isActive}
                        productName={item.title}
                        imageClass={item.icon}
                        addItem={this.handleAddAccesory.bind(this)}
                        removeItem={this.handleAddAccesory.bind(this)}
                        canUse={true}
                        cost={this.props.profile.currencySymbol + " " + item.subtitle}
                        isAccessory={true} />
                })
            }
        }

        let excessDropDown = [];
        if (this.props.sales.excessList.length > 0) {
            excessDropDown = this.props.sales.excessList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id}>{this.props.profile.currencySymbol} {item.description}</Dropdown.Item>
            });
        }

        return (
            <>
                <div className={this.props.auth.loggedIn ? "pt-lg-5 p-lg-0 logged-in" : "pt-lg-5 p-lg-0 logged-out"}>
                    <div className="container pt-3 pt-lg-0">
                        <div className="row justify-content-center QuoteDetails">
                            <div className="col-lg-6 col-12 pt-lg-3 pt-0 pb-lg-0 pb-3 mr-lg-4">
                                {this.props.sales.carDetails.agreedValue !== null &&
                                    <h3 className="Comprehensive-car mb-1">Comprehensive car insurance on agreed value</h3> ||
                                    <h3 className="Comprehensive-car mb-1">Comprehensive car insurance on retail value</h3>}
                                <p className="Comprehensive-details">{this.props.sales.vehicleYear} {this.props.sales.vehicleFullDescription}</p>
                            </div>
                            <div className="border-lg-right border-sm-bottom"></div>
                            <div className="col-lg-4 col-md-6 col-12 pt-lg-0 pt-3 mx-auto">
                                <p className="Comprehensive-monthly-premium mb-1 text-center">This month’s premium</p>
                                <p className="Comprehensive-total">{this.props.profile.currencySymbol} {this.props.sales.carPremium}</p>
                                <div className="text-center">
                                    <button className="btn btn-solid-green w-100" id='acceptQuoteTop' onClick={this.handleAcceptQuote}>{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</button>
                                </div>
                            </div>
                        </div>

                        <div className="row justify-content-center">
                            <div className="mt-3" id="ProductSummary">
                                <Tabs defaultActiveKey="home" id="uncontrolled-tab-example" className="ml-lg-5">
                                    <Tab eventKey="home" title="Overview" className="mb-4">
                                        {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                            <div className='row justify-content-center mt-15px mb-15px'>
                                                <AgreedValueBlock />
                                            </div>}
                                        <div className="Nutshell">
                                            <p className="productSummary-title mb-2">In a nutshell</p>
                                                <>
                                                {this.props.profile.countryId === SA_COUNTRY_ID_NUMBER &&
                                                        this.props.sales.carDetails.agreedValue !== null &&
                                                        <div className="col-12 nopa">
                                                            <ul className="mb-0px pl-25px">
                                                                <li>The agreed value that’s noted on your policy schedule refers to the amount that the car is covered for, for the 3 years following the start of the cover.</li>
                                                                <li>This agreed value must be, well, agreed on by you and us. It won’t depreciate, and so your car premium won’t decrease monthly.</li>
                                                                <li>Accessories and non-standard fitted extras must be noted on your policy schedule and a separate premium paid for them.</li>
                                                                <li>Cover under agreed value is dependent on your personal risk profile.</li>
                                                            </ul>
                                                        </div>
                                                    }
                                                <p className="mb-0">With the king's comprehensive cover, your premium decreases monthly as the value of your car drops! Saving-savvy or what?</p>
                                                </>
                                            <p style={{ visibility: "hidden" }} className="mb-0 d-none d-lg-block">Please leave this line.even if it doesn't make sense, This helps with the styling of this particular tab to look like the rest of the tabs and not</p>
                                            <hr />
                                            <p className="productSummary-title">Benefits</p>
                                            <div className="row">
                                                <div className="col-lg-3 col-12 quotation-benefits-col">
                                                    <p><div className="icon-checkmark-circle"></div>&nbsp;Roadside assist</p>
                                                </div>
                                                        <div className="col-lg-3 col-12 quotation-benefits-col">
                                                            <p><div className="icon-checkmark-circle"></div>&nbsp;Accident assist</p>
                                                        </div>
                                                        <div className="col-lg-3 col-12 quotation-benefits-col">
                                                            <p><div className="icon-checkmark-circle"></div>&nbsp;Medical assist</p>
                                                        </div>
                                                        <div className="col-lg-3 col-12 p-lg-0 quotation-benefits-col">
                                                            <p><div className="icon-checkmark-circle"></div>&nbsp;Liability to other parties</p>
                                                        </div>
                                            </div>
                                        </div>
                                        <div className="Nutshell mt-3" id="ComprehensiveDetails">
                                            <div className="row">
                                                <div className="col-lg-6 col-12">
                                                    <p className="productSummary-title mt-lg-3">Choose your excess</p>
                                                </div>
                                                <div className="col-lg-6 col-12">
                                                    <Dropdown className="fit-full"
                                                        onSelect={this.handleExcessSelection}
                                                        onToggle={this.handleExcessDropdownToggle}>
                                                        <Dropdown.Toggle id="dropdown-excess">
                                                            <div className="row">
                                                                <div className="col-10">
                                                                    {this.props.profile.currencySymbol} {this.props.sales.selectedExcess.description}
                                                                </div>
                                                                <Image src='Images/icons-arrow-dropdown-up-white-24-px.svg' className={this.state.selectedRegularDriverDropdown ? 'visible' : 'invisible'} alt="" />
                                                                <Image src='Images/icons-arrow-dropdown-down-white-24-px.svg' className={this.state.selectedRegularDriverDropdown ? 'invisible' : 'visible'} alt="" />
                                                            </div>
                                                        </Dropdown.Toggle>
                                                        <Dropdown.Menu>
                                                            {excessDropDown}
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <p className="ml-3 mt-4 mb-1 text-center"><strong>Please note:</strong> For certain claims and circumstances, an additional excess may apply. Check your policy schedule for more info.</p>
                                            </div>
                                            <hr />
                                            <div className="pt-3">
                                                <div id="optionalCover">
                                                    <p className="productSummary-title">Optional cover</p>
                                                    {vapsList}
                                                </div>
                                                <div id="accessories" className="mt-3 pt-5">
                                                    <p className="productSummary-title">Accessories</p>
                                                    {accessoryList}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row justify-content-center mt-3">
                                            <div className="col-12">
                                                <p className="Overview-only-Pleas">Overview only. Please refer to our <a target="_blank" href="/Content/documents/King-price-insurance-policy.pdf">KPPD</a> and your policy schedule for more info.</p>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="covered" title="What’s covered" className="mb-4">
                                        <div className="Nutshell">
                                            <h3 className="covered-title text-center mb-1">What's covered by the king</h3>
                                            <p className="mb-0 text-center">Here's what you're covered for:</p>
                                        </div>
                                        <div id="Covered" className="row mt-3">
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-covered-icons-roadside-assist mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Roadside assist</b></p>
                                                            <p className="coverDescription">Whether your battery, or tyres let you down...</p>
                                                            <p className="coverDescription">Help is just 1 call away</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-covered-icons-legal-liability mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Legal liability</b></p>
                                                            <p className="coverDescription">Liability due to an accident that causes damage to other people’s property = covered</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {this.props.profile.countryId !== 157 &&

                                                <div className="col-lg-6 col-12 mb-2">
                                                    <div className="Nutshells">
                                                        <div className="row">
                                                            <div className="col-3 col-lg-2 my-auto pr-0">
                                                                <div className="icons-covered-icons-accident-assist mx-auto d-block"></div>
                                                            </div>
                                                            <div className="col-9 col-lg-10 pb-3">
                                                                <p className="mt-2 mb-2"><b>Accident assist</b></p>
                                                                <p className="coverDescription">We don't like to think about this, but in the case of an accident, we've got your back</p>
                                                                <br />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 pr-0">
                                                            <div className="icons-covered-icons-accident mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-4 my-auto">
                                                            <p className="mt-3 mb-2"><b>Accident</b></p>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-covered-icons-hail-damage mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3 pr-0">
                                                            <p className="mt-2 mb-2"><b>Hail damage</b></p>
                                                            <p className="coverDescription">When the hailstones come a-pelting, the king and his court come a-helping</p>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-covered-icons-theft-or-hi-jack mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Theft or hi-jacking (including attempted theft and hi-jacking)</b></p>
                                                            <p className="coverDescription">When your car gets snatched, we'll help you get back on the tar ASAP</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-covered-icons-towing-n-storage mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Towing and storage</b></p>
                                                            <p className="coverDescription">Need a tow? Call our emergency assist line and we’ll handle the rest</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-covered-icons-natural-disasters mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Natural disasters</b></p>
                                                            <p className="coverDescription">Fire, explosion, earthquake, storm, flood, freezing or snow. Yep, it's all covered.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                    <Tab eventKey="notcovered" title="What’s not covered" className="mb-4">
                                        <div className="Nutshell">
                                            <h3 className="covered-title text-center mb-1">What's not covered</h3>
                                            <p className="mb-0 text-center">Here's what you're not covered for:</p>
                                        </div>
                                        <div id="NotCovered" className="row mt-3">
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells pb-5">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-dui mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Driving under the influence</b></p>
                                                            <p className="coverDescription">There's no cover when the person driving the car is under the influence of drugs or alcohol</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-use-without-consent mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>If your car's used without<br /> your consent</b></p>
                                                            <p className="coverDescription">If someone from your household uses your car without your consent and damages it, it won't be covered (sorry)</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells pb-5">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-leaving-the-scene-of-accident mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Leaving the scene of an accident</b></p>
                                                            <p className="coverDescription">If the driver of the car leaves the scene of an accident unlawfully, you won't be covered</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells pb-5">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-no-valid-drivers-licence mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pt-1 my-auto">
                                                            <p className="mt-3 mb-0"><b>Driving without a valid driver’s <br />licence or with an endorsed licence</b></p>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells pb-5">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-racing-or-earning-income mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Racing or using your car to earn an income</b></p>
                                                            <p className="coverDescription">Racing competitions, towing, or driving instruction? Nope, it's not covered</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells pb-5">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-modifications mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pt-1 my-auto">
                                                            <p className="mt-3 mb-0"><b>Modifications to enhance <br />engine performance</b></p>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-selling-your-car mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Selling your car</b></p>
                                                            <p className="coverDescription">Whether it's at a dealer or being sold by someone else... Your car won't be covered</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells pb-5">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-incorrect-fueling mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 my-auto">
                                                            <p className="mt-2 pt-3 mb-0"><b>Incorrect fueling</b></p>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-unroadworthy-car mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Unroadworthy car</b></p>
                                                            <p className="coverDescription">The king doesn't cover cars that don't meet official roadworthy requirements</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto">
                                                            <div className="icons-not-covered-icons-loss-damage-due-to-misplaced-keys mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 my-auto">
                                                            <p className="mt-3 mb-0"><b>Loss or damage due to<br /> misplaced keys</b></p>
                                                            <br />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12 mb-2">
                                                <div className="Nutshells">
                                                    <div className="row">
                                                        <div className="col-3 col-lg-2 my-auto pr-0">
                                                            <div className="icons-not-covered-icons-intentional-loss-damage mx-auto d-block"></div>
                                                        </div>
                                                        <div className="col-9 col-lg-10 pb-3">
                                                            <p className="mt-2 mb-2"><b>Intentional loss or damage</b></p>
                                                            <p className="coverDescription">We don't cover damage caused intentionally by you, those living with you, or with your knowledge/consent</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                        <div className="row justify-content-center mt-3">
                            <div className="col-12">
                                <div className="text-center">
                                    <button className="btn btn-solid-green" id="AddToQuote" onClick={this.handleAcceptQuote}><span className="Add-to-quote">{this.props.sales.isNewItem ? "Add to quote" : "Update quote"}</span> <br /> <span className="QuoteTotal">{this.props.profile.currencySymbol} {this.props.sales.carPremium} pm</span></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <AcceptQuote premuim={this.props.sales.carPremium} />
            </>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        sales: state.sales,
        auth: state.auth
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchUpdateExcess: (excessItem) => dispatch(updateExcess(excessItem)),
        dispatchShowAddVap: (vap) => dispatch(showAddVap(vap)),
        dispatchShowAddAccessory: (accessory) => dispatch(showAddAccessory(accessory)),
        dispatchShowAddCarHire: (vap) => dispatch(showAddCarHire(vap)),
        dispatchShowAddCreditShortfall: (vap) => dispatch(showAddCreditShortfall(vap)),
        dispatchShowTyreAndRim: (vap) => dispatch(showTyreAndRim(vap)),
        dispatchShowAddLittleDings: (vap) => dispatch(showAddLittleDings(vap)),
        dispatchShowErrorModal: (error) => dispatch(showErrorModal(error)),
        dispatchAcceptQuote: () => dispatch(navigateTo(BANKING_DETAILS)),
        dispatchUpdateItemOnQuote: () => dispatch(refreshUpdatedCartItem()),
        dispatchSetIsOnQuoteScreen: (flag, itemId, itemDescription) => dispatch(setIsOnQuoteScreen(flag, itemId, itemDescription)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarQuotation);